<template>
  <div>
    <div class="outmain heighthv pad_20 bor_rad5 ba_f">
      <div class="ba_f">
        <div class="mar_b20">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="$t('set.agreement.platformRule')" name="1"></el-tab-pane>
            <el-tab-pane :label="$t('set.agreement.riderRule')" name="2"></el-tab-pane>
          </el-tabs>
          <div class="t_l mar_b20 mar_t20">
            <el-button type="primary" size="medium" @click="handleEdit">{{ $t('set.agreement.add') }}</el-button>
          </div>
        </div>
        <el-table v-loading="listLoading" :element-loading-text="loadingText" :data="list" stripe style="width: 100%" @selection-change="setSelectRows">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="sort" :label="$t('common.sort')"></el-table-column>
          <el-table-column prop="title" :label="$t('set.agreement.ruleTitle')"></el-table-column>
          <el-table-column prop="createdAt" :label="$t('common.addTime')"></el-table-column>
          <el-table-column :label="$t('common.operation')">
            <template slot-scope="scope">
              <div class="flex">
                <el-button type="text" @click="handleEdit(scope.row)">{{ $t('common.view') }}</el-button>
                <el-button type="text" @click="handleDelete(scope.row)">{{ $t('common.delete') }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="page.total" :page-size="page.pagesize" :current-page.sync="page.currentPage" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="800px" :close-on-click-modal="false" @close="close">
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item :label="$t('set.agreement.ruleSort')" prop="sort" :required="true">
          <el-input v-model.trim="form.sort" autocomplete="off" :placeholder="$t('set.agreement.ruleSortPh')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('set.agreement.ruleTitle')" prop="title" :required="true">
          <el-input v-model.trim="form.title" autocomplete="off" :placeholder="$t('set.agreement.ruleTitlePh')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('set.agreement.ruleDetail')" prop="body" :required="true">
          <baidu-ueditor :content="form.body" @ueditor="getUeditor"></baidu-ueditor>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="close">{{ $t('common.cancel') }}</el-button>
        <el-button size="medium" type="primary" @click="save">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baiduUeditor from '@/plugins/baidu-ueditor';
import { agreementList, addRule, getRuleInfo, deleteRule } from '@/api/set';

export default {
  components: { baiduUeditor },
  data() {
    return {
      activeName: '1',
      list: [],
      title: '',
      listLoading: true,
      dialogFormVisible: false,
      selectRows: '',
      form: {
        id: '',
        sort: '',
        title: '',
        body: ''
      },
      page: {
        total: 0,
        size: 10,
        currentPage: 1
      }
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    loadingText() {
      return this.$t('common.loading');
    }
  },
  methods: {
    setSelectRows(val) {
      this.selectRows = val;
    },
    handleEdit(row) {
      if (row.id) {
        this.title = this.$t('common.edit');
        this.getRuleInfo(row.id);
      } else {
        this.title = this.$t('common.add');
      }
      this.dialogFormVisible = true;
    },
    handleClick() {
      this.fetchData();
    },
    handleDelete(row) {
      if (row.id) {
        this.$baseConfirm(this.$t('confirm.deleteItem'), null, async () => {
          const { msg } = await deleteRule({ id: row.id });
          this.$baseMessage(msg, 'success');
          this.fetchData();
        });
      }
    },
    getUeditor(content) {
      this.form.body = content;
    },
    async fetchData() {
      var params = {
        page: this.page.currentPage
      };
      if (this.activeName == '1') {
        params.type = 2;
      }
      if (this.activeName == '2') {
        params.type = 3;
      }
      const { data, count } = await agreementList(params);
      this.list = data;
      this.page.total = count;
      this.listLoading = false;
    },
    close() {
      this.$refs['form'].resetFields();
      this.form = this.$options.data().form;
      this.dialogFormVisible = false;
    },
    async getRuleInfo(id) {
      const { data } = await getRuleInfo({ id: id });
      this.form.sort = data.sort;
      this.form.title = data.title;
      this.form.body = data.body;
      this.form.id = data.id;
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          if (this.activeName == '1') {
            this.form.type = 2;
          }
          if (this.activeName == '2') {
            this.form.type = 3;
          }
          const { msg } = await addRule(this.form);
          this.$baseMessage(msg, 'success');
          this.fetchData();
          this.close();
        } else {
          return false;
        }
      });
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.fetchData();
    }
  }
};
</script>
